import PropTypes from 'prop-types';
import styled, { css } from 'styled-components/macro';

const positions = {};

positions.top = css`
  top: 10px;
`;

positions.topAvatar = css`
  top: 4px;
  right: 4px;
`;

positions.bottom = css`
  bottom: 10px;
`;

positions.center = css`
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const MediaButton = styled.button.attrs({
  type: 'button',
})`
  position: absolute;
  right: 10px;
  margin: 0;
  padding: 0;
  z-index: 1;

  &:hover path {
    fill: rgba(255, 255, 255, 0.8);
  }

  ${props => props.position === 'top' && positions.top}
  ${props => props.position === 'topAvatar' && positions.topAvatar}
  ${props => props.position === 'bottom' && positions.bottom}
  ${props => props.position === 'center' && positions.center}
`;

MediaButton.propTypes = {
  position: PropTypes.oneOf(Object.keys(positions)), // eslint-disable-line react/no-unused-prop-types
};

MediaButton.defaultProps = {
  position: 'top',
};

export default MediaButton;
